// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, anyOf, enumOf } from "@altostra/type-validations";
import { string, number, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isEmailIpWarmingAppGroupIdPlanResult = objectOf({
  ip_warming_plan: anyOf(
    objectOf({
      id: string,
      company_id: string,
      app_group_id: string,
      name: string,
      current_volume: number,
      target_volume: number,
      start_date: string,
      days_of_week: arrayOf(enumOf(0, 1, 2, 3, 4, 5, 6)),
      send_hours_start: maybe(string),
      send_hours_end: maybe(string),
      status: string,
      targeting_method: anyOf(maybe(string), nullValidation),
      itp_run_status: maybe(string),
      current_run_id: anyOf(maybe(string), nullValidation),
      current_run_started_at: anyOf(maybe(string), nullValidation),
      upload_identifier_type: anyOf(maybe(string), nullValidation),
      upload_row_count: anyOf(maybe(number), nullValidation),
      upload_unique_identifier_count: anyOf(maybe(number), nullValidation),
      upload_matched_profile_count: anyOf(maybe(number), nullValidation),
      upload_file_name: anyOf(maybe(string), nullValidation),
      upload_file_download_link: anyOf(maybe(string), nullValidation),
      ranks_written_status: maybe(string),
      rank_write_failure_code: anyOf(maybe(string), nullValidation),
      upload_file_size_bytes: anyOf(maybe(number), nullValidation),
      schedule_entries: arrayOf(
        objectOf({
          date: string,
          planned_volume: number,
          email_template_id: anyOf(maybe(string), nullValidation),
          campaign_id: anyOf(maybe(string), nullValidation),
        })
      ),
      mailbox_providers_to_throttle: maybe(arrayOf(string)),
      user_segment_ids: maybe(arrayOf(string)),
      email_template_ids: maybe(arrayOf(string)),
      from_email_address: maybe(
        objectOf({
          display_name: string,
          local_part: string,
          domain_id: string,
          domain: string,
          ip_pool_id: string,
        })
      ),
    }),
    nullValidation
  ),
});
